import Modal from "~components/Modal";
import { SearchUser } from "~misc/icons";
import Select from "~components/Form/components/Select";
import "./style.scss";
import useClientes from "~/fetchs/useClientes";

const ProspectConversionModal = ({ isOpen, onClose, handleConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      sub={<Content handleConfirm={handleConfirm} />}
      hideButtonOne={true}
      hideButtonTwo={true}
    />
  );
};

const Content = ({ handleConfirm }) => {
  const { clienteSelect, onChangeCliente, handleSearch, options } = useClientes({
    type: "optionsConversaoProspect",
    campo: "simulador",
    enabledRequest: false
  });

  return (
    <>
      <h2 className="text-lg mb-8 max-w-[300px] mx-auto font-bold text-primaria">
        Busque o cliente que deseja vincular este prospect
      </h2>

      <div className="flex items-stretch gap-[1rem] text-left">
        <label className="search-label h-[initial]">
          <SearchUser className="icon" />
          <Select
            name="simulador"
            label=""
            className="!w-[250px]"
            placeholder="Digite para Buscar o Cliente"
            options={options}
            noOptionsMessage="Cliente não encontrado"
            onChange={(e) => onChangeCliente(e)}
            onInputChange={handleSearch}
            {...clienteSelect}
          />
        </label>

        <button
          type="button"
          onClick={() => {
            const { value: clienteId } = clienteSelect.value
            handleConfirm(clienteId);
          }}
          className={`px-6 py-3 rounded bg-secundaria text-primaria font-bold  hover:bg-white hover:text-secundaria border-2 border-secundaria border-quartenaria transition duration-300 ease-in-out`}
        >
          Enviar
        </button>
      </div>
    </>
  );
};

export default ProspectConversionModal;
